// extracted by mini-css-extract-plugin
export default {"errorPage":"NotFound_errorPage__XOebI","error_container":"NotFound_error_container__m4Hoj","zoom_area":"NotFound_zoom_area__s46SC","link_container":"NotFound_link_container__Wsf6N"};